import { render, staticRenderFns } from "./order-delivery.vue?vue&type=template&id=6448aba6&scoped=true&"
import script from "./order-delivery.vue?vue&type=script&lang=js&"
export * from "./order-delivery.vue?vue&type=script&lang=js&"
import style0 from "./order-delivery.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./order-delivery.vue?vue&type=style&index=1&id=6448aba6&scoped=true&lang=scss&"
import style2 from "./order-delivery.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6448aba6",
  null
  
)

export default component.exports